import ConfirmBox from "@/components/common/Confirm";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import DayJS from "dayjs";
import Model from "../../../../../components/common/Model";
import Select from "../../../../../components/common/Select";
import ChainedContext from "../../../../../contexts/chainedContext";
import MemberReceiver from "../../../../../contexts/member_context/Member_Receiver";
import API from "../../../../../api";
import TextArea from "../../../../../components/common/TextArea";
import { toast } from "react-hot-toast";

const QuickCourseEdit = ({ onClose, courseResult, member }) => {
  const [startAt, setStartAt] = useState(new Date());
  const [expiresAt, setExpiresAt] = useState(new Date());
  const [course, setCourse] = useState("");
  const [isPass, setIsPass] = useState("");
  const [comment, setComment] = useState("");
  const [pickableCourses, setPickableCourses] = useState([]);
  const [deleteConfirm, setDeleteConfirm] = useState(false);

  useEffect(() => {
    API.courses.list().then((res) => {
      setPickableCourses(res);
    });
  }, []);
  useEffect(() => {
    setStartAt(DayJS(courseResult.startAt).toDate());
    setExpiresAt(DayJS(courseResult.startexpiresAtAt).toDate());
    setCourse(courseResult.course._id);
    setIsPass(courseResult.isPass);
    setComment(courseResult.comment);
  }, [courseResult]);

  const handleSubmit = () => {
    API.courses
      .quickUpdateResult(courseResult._id, {
        course,
        startAt,
        expiresAt,
        isPass,
        comment
      })
      .then(() => {
        toast.success("Updated course result successfully.");
        onClose();
      })
      .catch((err) => {
        let errorMessage = "There has been and error";
        if (err.isAxiosError !== undefined) {
          if (err.response.data.message !== undefined) {
            errorMessage = err.response.data.message;
          }
        }
        toast.error(errorMessage);
      });
  };
  const handleDelete = () => {
    API.courses.quickCourseResultDelete(courseResult._id).then(() => {
      toast.success("Course result deleted successfully.");
      onClose();
    })
    .catch((err) => {
      let errorMessage = "There has been and error";
      if (err.isAxiosError !== undefined) {
        if (err.response.data.message !== undefined) {
          errorMessage = err.response.data.message;
        }
      }
      toast.error(errorMessage);
    });
  };

  const updateExpiryDate = (newValue, newStartAt) => {
    if(newValue === "") return;

    const theCourse = pickableCourses.find((a) => a._id === newValue);
    if (theCourse) {
      setExpiresAt(DayJS(newStartAt).add(theCourse.validFor, "years").toDate());
    }
  }

  if(deleteConfirm){
    return (
      <ConfirmBox
        show={true}
        title={"Delete selected course result"}
        onClose={() => setDeleteConfirm(false)}
        action={() => handleDelete()}
      />
    );
  }

  return (
    <Model title={"Quick Course Edit"} onClose={onClose} disableOutsideClick>
      <div className="w-full">
        <Select
          label="Course"
          options={pickableCourses.map((item) => {
            return {
              key: item._id,
              text: item.name,
              value: item._id,
            };
          })}
          value={course}
          onChange={(e) => {
            updateExpiryDate(e.target.value, startAt)
            setCourse(e.target.value)
          }}
        />
      </div>
      {course !== "" && (
        <div className="grid grid-cols-2 gap-2 space-y-2">
          <div className="overflow-show w-full">
            <label htmlFor={"date"} className={`labelClass`}>
              Course/Valid From Date
            </label>
            <DatePicker
              onChange={(date) => {
                updateExpiryDate(course, date)
                setStartAt(date);
              }}
              selected={startAt ? new Date(startAt) : ""}
              dateFormat="dd-MM-yy"
              nextMonthButtonLabel=">"
              previousMonthButtonLabel="<"
              className=" inputClass"
              data-disable-touch-keyboard
            />
          </div>
          <div className="overflow-show w-full">
            <label htmlFor={"date"} className={`labelClass`}>
              Expiry Date
            </label>
            <DatePicker
              onChange={(date) => setExpiresAt(date)}
              selected={expiresAt ? new Date(expiresAt) : ""}
              dateFormat="dd-MM-yy"
              nextMonthButtonLabel=">"
              previousMonthButtonLabel="<"
              className="inputClass"
              data-disable-touch-keyboard
            />
          </div>
          <div className="w-full">
            <Select
              label="Result"
              options={[
                { key: 1, text: "Failed", value: false },
                { key: 2, text: "Passed", value: true },
              ]}
              value={isPass}
              onChange={(e) => setIsPass(e.target.value)}
            />
          </div>
          <div className="col-span-2">
            <TextArea
              label="Comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </div>
        </div>
      )}

      <div className="mt-4 flex justify-between border-t border-zinc-500 pt-4">
        <button
          className="rounded-lg bg-primary px-4 py-2 text-white"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          className="rounded-lg bg-red-500 px-4 py-2 text-white"
          onClick={() => setDeleteConfirm(true)}
        >
          Delete
        </button>
        <button
          className="rounded-lg bg-green-500 px-4 py-2 text-white disabled:bg-green-500"
          onClick={handleSubmit}
        >
          Save
        </button>
      </div>
    </Model>
  );
};
export default ChainedContext(QuickCourseEdit, [[MemberReceiver, "member"]]);
